import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "height"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled, { css } from 'styled-components';
import ButtonCore from 'components/ButtonCore';
import { pxToRem } from 'utils/ui/units';
import { spacing, breakpoints } from 'styles/globals';
import { overflowWrap } from 'styles/mixins';
import { jsx as _jsx } from "react/jsx-runtime";
var tabPropNames = ['stackBelow', 'width', 'height', 'undimmed', 'allowTextWrap'];
var Wrapper = styled(ButtonCore).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !tabPropNames.includes(prop);
  }
}).withConfig({
  displayName: "Tab__Wrapper",
  componentId: "sc-t2vtii-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;flex:1 1 auto;flex-direction:row;", " padding:", " 0;color:", ";letter-spacing:0.02em;text-decoration:none;", " ", " overflow:hidden;cursor:", ";transition:opacity 0.25s linear;will-change:opacity;", " &::after{content:'';position:absolute;left:0;bottom:0;right:0;display:block;height:", ";background-color:", ";transform:translateY(110%);transition:transform 250ms ease-out;will-change:transform;", "}&.is-active{font-weight:bold;letter-spacing:0;opacity:1;&::after{transform:translateY(0);transition-timing-function:ease-in;}}&:hover,&:focus{opacity:1;transition:none;}"], function (p) {
  return p.height && css(["height:", ";"], function (p) {
    return pxToRem(p.height);
  });
}, spacing.xxs, function (p) {
  return p.theme.text;
}, function (p) {
  return p.allowTextWrap && overflowWrap;
}, function (p) {
  return !p.undimmed && css(["opacity:", ";"], function (p) {
    return p.theme.textDimStrength;
  });
}, function (p) {
  return p.disabled ? 'default' : 'pointer';
}, function (p) {
  return p.stackBelow && css(["@media (max-width:", "){flex-direction:column;}"], breakpoints[p.stackBelow]);
}, spacing.xxs, function (p) {
  return p.theme.links;
}, function (p) {
  return p.disabled && css(["opacity:0;"]);
});
export var Tab = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    height = _ref.height,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'a';
  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({}, otherProps), {}, {
    height: height,
    ref: ref,
    forwardedAs: Component
  }));
});
Tab.displayName = 'Tab';
export default Tab;